<template>
  <div class="container">
    <h1>登录中...</h1>
    <p>如无法跳转请点击授权按钮</p>
    <a-button type="primary" @click="authM">授权</a-button>
  </div>
</template>

<script>
import { auth,initAgentConfig } from "@/utils/wxCodeAuth";
import {checkMixin} from "@/mixins/checkMixin"
export default {
  name: "login",
  data() {
    return {
      corpId: "", //企微id
      agentId: "", //应用id
    };
  },
  mixins: [checkMixin],
  methods: {
    async initLogin() {
    //  if (!window.wx || !window.wx.config || !window.wx.agentConfig)
    //    return this.$alert("非企业微信环境");
    //  else console.log("wx", window.wx);

      await this.authM();
      console.log("已经登录了哦，开始获取配置");

      await initAgentConfig()
      console.log("检查是否初始化配置完成");

      // 检查是否已绑定crm账号-由于不是硬性要求所以改成页面按需调用
      // this.checkIsBindM()
      
      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect);
        console.log("已完成登录校验，开始跳转重定向页面");
      }
    },
    async authM() {
      return new Promise(async(resolve, reject) => {
        let res = await auth(this.corpId, this.agentId, this.redirectUrl);
        console.log("授权和登录完成", res);
        resolve()
      })
    },
  },
  async created() {
    // 侧边栏表单id携带为/，其余属于?后携带参数
    // 1.获取?后的参数用于初始化
    this.corpId = this.$route.params.corpId;
    this.agentId = this.$route.params.agentId;
    // 2.初始化配置信息
    this.initLogin();
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  p {
    color: #ccc;
    margin-top: 50px;
  }
}
</style>

